import { Close } from '@mui/icons-material';
import { Button, Drawer, IconButton, styled, Typography } from '@mui/material';
import { L } from 'harmony-language';
import React from 'react';
import { ComparisonFilter } from './table-components/filters/comparison-filter';
import { CustomerFilter } from './table-components/filters/customer-filter';
import { DriverPropertiesFilter } from './table-components/filters/driver-properties-filter';
import { LocationGroupFilter } from './table-components/filters/location-group-filter';
import { MedicationFilter } from './table-components/filters/medication-filter';
import { getActiveDrawerFilters, removeDrawerFilters } from './utils/drafts-loads-utils';

interface DraftLoadFilterDrawerProps {
    isDrawerOpen: boolean;
    closeDrawer: () => void;
    table: any;
}

export const DraftLoadFilterDrawer = (props: DraftLoadFilterDrawerProps) => {
    const { isDrawerOpen, closeDrawer, table } = props;

    const activeDrawerFilters = getActiveDrawerFilters(table);
    const hasActiveDrawerFilters = activeDrawerFilters && activeDrawerFilters.length > 0;

    return (
        <Drawer open={isDrawerOpen} anchor='right' onClose={closeDrawer}>
            <div style={{ padding: '1rem 2rem', minWidth: '20rem' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', paddingBottom: '1rem' }}>
                    <Typography variant='h5'>{L.filters()}</Typography>
                    <div style={{ display: 'flex', alignItems: 'start', gap: '1rem' }}>
                        {hasActiveDrawerFilters && <Button
                            variant='text'
                            size='small'
                            onClick={() => removeDrawerFilters(table)}
                        >
                            {L.clearAll()}
                        </Button>}
                        <IconButton onClick={closeDrawer} style={{ padding: 0 }}><Close /></IconButton>
                    </div>
                </div>
                <FilterWrapper>
                    <ComparisonFilter table={table} />
                </FilterWrapper>
                <FilterWrapper>
                    <CustomerFilter
                        table={table}
                    />
                </FilterWrapper>
                <FilterWrapper>
                    <DriverPropertiesFilter table={table} />
                </FilterWrapper>
                <FilterWrapper>
                    <LocationGroupFilter table={table} />
                </FilterWrapper>
                <FilterWrapper>
                    <MedicationFilter table={table} />
                </FilterWrapper>
            </div>
        </Drawer>
    )
}

const FilterWrapper = styled('div')({
    padding: '0'
});